import marka from '@components/search/inputs/markaAgri'
import model from '@components/search/inputs/modelNone'
import cena from '@components/search/inputs/cena'
import stan from '@components/search/inputs/stan'
import rata from '@components/search/inputs/rata'
import rocznik from '@components/search/inputs/rocznik'
import szukaj from '@components/search/inputs/szukaj'
import motogodziny from '@components/search/inputs/motogodziny'
import lokalizacja from '@components/search/inputs/lokalizacjaZasieg'

const agriFormInputsMobile = [
    marka,
    model,
    cena,
    rata,
    lokalizacja,
    stan,
    motogodziny,
    rocznik,
    szukaj,
]

const agriFormInputs = [
    marka,
    cena,
    stan,
    model,
    rata,
    rocznik,
    szukaj,
    motogodziny,
    lokalizacja
]

export {
    agriFormInputsMobile,
    agriFormInputs,
}


